/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { createSelector, createStructuredSelector } from 'reselect';
import PropTypes from 'prop-types';

import ggAddress from 'ggApp/modules/address';
import ggPayment from 'ggApp/modules/payment';
import ggRouter from 'ggApp/modules/router';
import ggLayout from 'ggApp/modules/layout';
import ggAdyen from 'ggApp/modules/adyen';
import { TranslatorComponent_Text as Translator } from 'ggApp/modules/translator';
import DisplayIf from 'ggApp/shared/components/viewport';
import { getTranslation } from 'ggApp/utils/text';

import SslIcon from './images/ssl.svg';
import TrustBadges from './trustBadgesMobile';
import { navigatorCheckoutPages, NAVIGATOR_OPEN_CLASS } from '../../../constants';
import * as ggNavigatorSelectors from '../../../selectors';
import * as ggNavigatorActions from '../../../actions';
import GgNavigatorStatusList from '../statusList';
import { Navigation, Wrap, Logo, Close, Footer, ReviewIO } from './styles';

@connect(
    createStructuredSelector({
        routeProps: ggRouter.selectors.routeProps,
        statusBarCheckout: ggNavigatorSelectors.statusBarCheckout,
        naviData: createSelector(
            ggAddress.selectors.activeAddressShippingNavi,
            createSelector(
                ggAddress.selectors.activeAddressBillingNavi,
                ggPayment.selectors.activePaymentMethodNavi,
                ggAdyen.selectors.savedPaymentDataNavigator,
                (addressBilling, payment, adyenSavedPayment) => {
                    if (adyenSavedPayment.length !== 0) {
                        return adyenSavedPayment.concat(addressBilling);
                    }
                    return payment.concat(addressBilling);
                },
            ),
            (address, payment) => ({
                address,
                payment,
            }),
        ),
    }),
    (dispatch) => ({ dispatch }),
)
class CheckoutNavigator extends Component {
    // eslint-disable-next-line react/static-property-placement
    static contextTypes = {
        store: PropTypes.arrayOf(PropTypes.object),
    };

    componentWillReceiveProps(nextProps) {
        if (!nextProps.statusBarCheckout) {
            ggLayout.actions.addBodyClass(NAVIGATOR_OPEN_CLASS);
            ggLayout.actions.addHtmlClass(NAVIGATOR_OPEN_CLASS);
        } else {
            this.removeNavigatorClasses();
        }
    }

    removeNavigatorClasses = () => {
        ggLayout.actions.removeBodyClass(NAVIGATOR_OPEN_CLASS);
        ggLayout.actions.removeHtmlClass(NAVIGATOR_OPEN_CLASS);
    };

    render() {
        const { routeProps, naviData, statusBarCheckout, dispatch } = this.props;
        const { store } = this.context;
        const { navigatorName } = routeProps;
        const pageNames = navigatorCheckoutPages.map((p) => p.name);

        const list = [
            {
                title: getTranslation(store, 'CHECKOUT_BADGE_SSL_TITLE'),
                secondaryTitle: getTranslation(store, 'CHECKOUT_BADGE_SSL_SEC'),
                icon: SslIcon,
            },
        ];

        const CheckoutNavigatorList = (
            <GgNavigatorStatusList
                navigationPages={navigatorCheckoutPages}
                navigatorName={navigatorName}
                pageNames={pageNames}
                naviData={naviData}
            />
        );
        const DesktopView = (
            <Navigation>
                <Wrap>
                    <Logo />
                    {CheckoutNavigatorList}
                </Wrap>
            </Navigation>
        );
        const MobileView = (
            <Navigation hide={statusBarCheckout}>
                <Close onClick={() => dispatch(ggNavigatorActions.statusBarCheckoutTrigger())} />
                <Wrap>
                    {CheckoutNavigatorList}
                    <Footer>
                        <TrustBadges list={list} />
                        <ReviewIO color="#FFF" noStars />
                        <Translator
                            tk="NAVIGATOR_FOOTER"
                            withValues={{
                                copyrightYear: new Date().getFullYear(),
                            }}
                        />
                    </Footer>
                </Wrap>
            </Navigation>
        );

        return (
            <div>
                <DisplayIf desktop largeDesktop widescreen>
                    {DesktopView}
                </DisplayIf>
                <DisplayIf mobile tablet>
                    {MobileView}
                </DisplayIf>
            </div>
        );
    }
}

export default CheckoutNavigator;
